/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_Funnel_Stage_OfferInputs */

const en_analytics_funnel_stage_offer = /** @type {(inputs: Analytics_Funnel_Stage_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offer`)
};

const de_analytics_funnel_stage_offer = /** @type {(inputs: Analytics_Funnel_Stage_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angebot`)
};

const fr_analytics_funnel_stage_offer = /** @type {(inputs: Analytics_Funnel_Stage_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offre`)
};

const es_analytics_funnel_stage_offer = /** @type {(inputs: Analytics_Funnel_Stage_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oferta`)
};

const it_analytics_funnel_stage_offer = /** @type {(inputs: Analytics_Funnel_Stage_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offerta`)
};

const nl_analytics_funnel_stage_offer = /** @type {(inputs: Analytics_Funnel_Stage_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aanbod`)
};

const pl_analytics_funnel_stage_offer = /** @type {(inputs: Analytics_Funnel_Stage_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oferta`)
};

const fi_analytics_funnel_stage_offer = /** @type {(inputs: Analytics_Funnel_Stage_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarjous`)
};

const da_analytics_funnel_stage_offer = /** @type {(inputs: Analytics_Funnel_Stage_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilbud`)
};

const sv_analytics_funnel_stage_offer = /** @type {(inputs: Analytics_Funnel_Stage_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erbjudande`)
};

/**
* | output |
* | --- |
* | "Offer" |
*
* @param {Analytics_Funnel_Stage_OfferInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const analytics_funnel_stage_offer = /** @type {((inputs?: Analytics_Funnel_Stage_OfferInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_Funnel_Stage_OfferInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_analytics_funnel_stage_offer(inputs)
	if (locale === "fr") return fr_analytics_funnel_stage_offer(inputs)
	if (locale === "es") return es_analytics_funnel_stage_offer(inputs)
	if (locale === "it") return it_analytics_funnel_stage_offer(inputs)
	if (locale === "nl") return nl_analytics_funnel_stage_offer(inputs)
	if (locale === "pl") return pl_analytics_funnel_stage_offer(inputs)
	if (locale === "fi") return fi_analytics_funnel_stage_offer(inputs)
	if (locale === "da") return da_analytics_funnel_stage_offer(inputs)
	if (locale === "sv") return sv_analytics_funnel_stage_offer(inputs)
	return en_analytics_funnel_stage_offer(inputs)
});